// action-bar.tsx
import React from 'react';
import { cn } from '@utils';
import { ActionBarProps, ActionBarRoles } from './action-bar.type';

const ActionBar: React.FC<ActionBarProps> = ({ actions, className, ariaLabel }) => {
	if (actions.length === 0) {
		return null;
	}

	return (
		<div
			data-aid="ActionBar"
			className={cn('flex space-x-2 mb-2', className)}
			role={ActionBarRoles.Toolbar}
			aria-label={ariaLabel}
		>
			{actions.map((action, index) => (
				<div key={index} role={ActionBarRoles.None}>
					{React.isValidElement(action)
						? React.cloneElement(action, {
								tabIndex: 0,
								'aria-label': (action as React.ReactElement).props['aria-label'] || `Action ${index + 1}`,
							} as unknown as React.ReactElement)
						: action}
				</div>
			))}
		</div>
	);
};

export { ActionBar };
